import { call, put, takeLatest } from 'redux-saga/effects';
import axios from '../../services/axios';
import * as Actions from './actions';
import { ActionTypes as PagesActions } from '../../pages/actions';

// Fetch messages
function* fetchMessages(action) {
    try {
        const { inquiryId, page = 0, take = 10, unreadOnly } = action.payload;
        
        let queryParams = `page=${page}&take=${take}`;
        if (inquiryId) queryParams += `&inquiryId=${inquiryId}`;
        if (unreadOnly) queryParams += `&unreadOnly=true`;

        yield put(Actions.FETCH_MESSAGES_REQUEST());
        
        const { data } = yield call(axios.get, `/messages?${queryParams}`);
        
        // Backend returns { data: messages[], count: number }
        yield put(Actions.FETCH_MESSAGES_SUCCESS({
            data: data.data,
            count: data.count
        }));
    } catch (err) {
        console.error('Failed to fetch messages:', err);
        yield put(Actions.FETCH_MESSAGES_FAILURE(err));
    }
}

// Fetch single message
function* fetchSingleMessage(action) {
    try {
        const { messageId } = action.payload;
        
        yield put(Actions.FETCH_SINGLE_MESSAGE_REQUEST());
        
        const { data } = yield call(axios.get, `/messages/${messageId}`);
        
        yield put(Actions.FETCH_SINGLE_MESSAGE_SUCCESS(data));
    } catch (err) {
        console.error('Failed to fetch message:', err);
        yield put(Actions.FETCH_SINGLE_MESSAGE_FAILURE(err));
    }
}

// Send message
function* sendMessage(action) {
    try {
        const { messageData, files } = action.payload;
        
        yield put(Actions.SEND_MESSAGE_REQUEST());
        
        // Create FormData for files
        const formData = new FormData();
        formData.append('inquiryId', messageData.inquiryId);
        formData.append('subject', messageData.subject);
        formData.append('body', messageData.body);
        formData.append('toEmail', messageData.toEmail);
        
        if (messageData.parentMessageId) {
            formData.append('parentMessageId', messageData.parentMessageId);
        }
        
        // Add files if any - backend expects field name 'attachments'
        if (files && files.length > 0) {
            files.forEach(file => {
                formData.append('attachments', file);
            });
        }
        
        const { data } = yield call(axios.post, '/messages', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        
        yield put(Actions.SEND_MESSAGE_SUCCESS(data));
    } catch (err) {
        console.error('Failed to send message:', err);
        yield put(Actions.SEND_MESSAGE_FAILURE(err));
    }
}

// Mark message as read
function* markMessageRead(action) {
    try {
        const { messageId } = action.payload;
        
        yield put(Actions.MARK_MESSAGE_READ_REQUEST());
        
        yield call(axios.patch, `/messages/${messageId}/read`);
        
        yield put(Actions.MARK_MESSAGE_READ_SUCCESS(messageId));
    } catch (err) {
        console.error('Failed to mark message as read:', err);
        yield put(Actions.MARK_MESSAGE_READ_FAILURE(err));
    }
}

const sagas = [
    takeLatest(PagesActions.MESSAGES_PAGE_MOUNTED, fetchMessages),
    takeLatest(PagesActions.SINGLE_MESSAGE_PAGE_MOUNTED, fetchSingleMessage),
    takeLatest(PagesActions.SEND_MESSAGE_SUBMITTED, sendMessage),
    takeLatest(PagesActions.MARK_MESSAGE_READ, markMessageRead),
];

export default sagas;

